import { STORAGE_KEY } from '@/common/constants';

type CookieApprove = {
	submitted: boolean;
	value: boolean;
};

const getDefault = (): CookieApprove => {
	return { submitted: false, value: false };
};

export function useCookieApprove() {
	const storage = useLocalStorage();

	function getValue(): CookieApprove {
		try {
			const value = storage.getItem(STORAGE_KEY.cookie);

			return value?.length ? JSON.parse(value) : getDefault();
		} catch (error) {
			return getDefault();
		}
	}

	function submit() {
		const value: CookieApprove = {
			submitted: true,
			value: true
		};

		storage.setItem(STORAGE_KEY.cookie, JSON.stringify(value));
	}

	function isSubmitted() {
		return getValue().submitted;
	}

	return { isSubmitted, getValue, submit };
}
